import {Divider} from '@/components/ui/divider/Divider'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ExtendsCycleProjectFormProvider} from '@/features/projects/components/project-form/extends-cycle-project-form-provider/ExtendsCycleProjectFormProvider'
import {ExtendsCycleProjectFormSections} from '@/features/projects/components/project-form/extends-cycle-project-form-sections/ExtendsCycleProjectFormSections'
import {ProjectFormHeading} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeading'
import {ExtendsProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {useToggle} from '@/hooks/useToggle'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {ExtendsCycleConfirmationModal} from '@/features/projects/components/exteds-cycle-confirmation-modal/ExtendsCycleConfirmationModal'

export const ProjectExtendsCycle = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {on: showConfirmationModal, off: hideConfirmationModal, isActive: isConfirmationModalVisible} = useToggle()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    if (!permissions?.projects.write) {
        return <NoPermissionBox />
    }

    return (
        <PageCardWrapper>
            <Helmet title={t('projects:extends_cycle_meta_title')} />
            <ExtendsCycleProjectFormProvider project={project}>
                <ProjectFormHeading
                    title={t('projects:extends_cycle_title')}
                    schema={ExtendsProjectFormValidationSchema}
                    showConfirmationModal={showConfirmationModal}
                />
                <Divider direction="horizontal" />
                <PageContent padding={0}>
                    <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                        <ExtendsCycleProjectFormSections isExtendable={project.type == 'cyclic'} />
                    </ScrollArea>
                </PageContent>
                {isConfirmationModalVisible && (
                    <ExtendsCycleConfirmationModal projectId={project.id} hide={hideConfirmationModal} />
                )}
            </ExtendsCycleProjectFormProvider>
        </PageCardWrapper>
    )
}
